import thunk from "redux-thunk";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { RootModel } from "types/rootModel.d";
import {
  init,
  RematchDispatch,
  RematchRootState,
  RematchStore,
} from "@rematch/core";

import history from "./history";
import { models } from "./models";

const router = routerMiddleware(history);
const middlewares = [router, thunk];

export const store = init({
  models,
  redux: {
    reducers: {
      router: connectRouter(history),
    },
    devtoolOptions: {
      realtime: true,
      name: "CommuniConnect",
    },
    middlewares,
  },
});

export type Store = RematchStore<RootModel, {}>;
export type Dispatch = RematchDispatch<RootModel>;
export type RootState = RematchRootState<RootModel>;
